// Mock data for L'Agence website

export const testimonials = [
  {
    id: 1,
    name: "Jean-Pierre Mukendi",
    position: "Directeur Général",
    company: "Congo Mining Corp",
    image: "https://images.unsplash.com/photo-1764169689207-e23fb66e1fcf",
    quote: "L'Agence a transformé notre gestion des voyages d'affaires. Leur disponibilité 24/7 et leur professionnalisme sont incomparables. Nous avons gagné un temps précieux pour nous concentrer sur notre cœur de métier."
  },
  {
    id: 2,
    name: "Marie Kalala",
    position: "Directrice des Ressources Humaines",
    company: "Telecom RDC",
    image: "https://images.unsplash.com/photo-1633419798503-0b0c628f267c",
    quote: "Organisation impeccable de nos séminaires internationaux. L'Agence coordonne tout avec une précision remarquable, de la billeterie aux événements sur place. Un service véritablement exclusif."
  },
  {
    id: 3,
    name: "Patrick Nsimba",
    position: "Directeur Commercial",
    company: "BanCongo Financial",
    image: "https://images.unsplash.com/photo-1703059680709-d9554370fff9",
    quote: "Pour nos déplacements multi-pays, L'Agence est devenue indispensable. Leur service clés-en-main nous permet de nous concentrer uniquement sur nos objectifs business. Excellent rapport qualité-service."
  }
];

export const services = [
  {
    id: 1,
    title: "Billeterie Corporate",
    slug: "billeterie-corporate",
    description: "Gestion complète de vos billets d'avion 24/7 avec optimisation des coûts et suivi personnalisé.",
    features: [
      "Recherche et émission de billets",
      "Modifications et annulations",
      "Optimisation des coûts",
      "Gestion des miles corporate",
      "Suivi passagers 24/7",
      "Reporting mensuel",
      "Gestion des urgences",
      "Centralisation multi-équipes"
    ]
  },
  {
    id: 2,
    title: "Affrètement d'Avions",
    slug: "affretement",
    description: "Affrètement d'avions privés et charters pour vos équipes en RDC et partout dans le monde.",
    features: [
      "Avions privés & charters",
      "Vols réguliers RDC",
      "Déplacements internationaux",
      "Transport de personnel",
      "Évacuations médicales",
      "Missions d'urgence",
      "Logistique aérienne",
      "Coordination complète"
    ]
  },
  {
    id: 3,
    title: "Voyages d'Affaires Clés-en-Main",
    slug: "voyages-affaires",
    description: "Organisation complète de vos déplacements professionnels avec coordination dans le moindre détail.",
    features: [
      "Transport & billeterie",
      "Chauffeurs privés",
      "Hébergement premium",
      "Réservations restaurants",
      "Salles de réunion",
      "Services VIP aéroport",
      "Fast-track & lounge",
      "Assistance 24/7"
    ]
  },
  {
    id: 4,
    title: "Événements Corporate",
    slug: "evenements-corporate",
    description: "Conception et gestion d'événements professionnels internationaux avec exécution premium.",
    features: [
      "Séminaires & retraites",
      "Team buildings",
      "Conférences",
      "Voyages incentives",
      "Délégations internationales",
      "Galas & dîners",
      "Production complète",
      "Coordination sur site"
    ]
  }
];

export const stats = [
  {
    value: "24/7",
    label: "Disponibilité"
  },
  {
    value: "15+",
    label: "Pays Couverts"
  },
  {
    value: "100%",
    label: "Sur Mesure"
  },
  {
    value: "Service",
    label: "Exclusif"
  }
];

export const eventTypes = [
  "Séminaires de direction",
  "Retraites exécutives",
  "Team buildings",
  "Conférences et ateliers",
  "Voyages de récompense (incentives)",
  "Délégations internationales",
  "Galas & dîners institutionnels",
  "Lancements de projets"
];

export const clientTypes = [
  "Grandes entreprises",
  "PME",
  "ONG",
  "Multinationales",
  "Départements RH & Finance",
  "Directions générales",
  "Équipes en mission régulière"
];